import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useMemo } from "react";
import TodaysAppointmentsTable from "./TodaysAppointmentsTable";
import { Panel, PanelGroup, Placeholder } from "rsuite";
import Offcanvas from "react-bootstrap/Offcanvas";
import TodaysAppointmentGrid from "./TodaysAppointmentGrid";

function TodaysAppointments() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [expanded, setExpanded] = React.useState(false);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const [viewType, setViewType] = useState("List");
  const navigate = useNavigate();

  const styleaccordion = `

  .rs-panel-group-bordered {
    border: none;
  }

  .rs-panel-group {
    border-radius: none;
    overflow: hidden;
  }

  .rs-panel-btn:active, .rs-panel-btn:focus, .rs-panel-btn:hover{
    background-color: none !important;
  }

  .rs-panel:last-child {
    border-bottom: none !important;
  }

  .rs-panel-btn:active, .rs-panel-btn:focus, .rs-panel-btn:hover {
    background-color: #fff !important;
    color: #343434;
    color: var(--rs-btn-subtle-hover-text);
    outline: 2px solid transparent;
}

.rs-panel-title {
    -ms-flex: 1 1 0%;
    flex: 1 1;
    margin: 0;
    text-align: left;
    font-weight: 500 !important;
    color: #000;
}

.rs-panel-collapsible>.rs-panel-header {
    cursor: pointer;
    padding: 3px;
    position: relative;
    -webkit-transition: background-color .3s linear, border-radius .3s linear;
    transition: background-color .3s linear, border-radius .3s linear;
}

.offcanvas-body {
    flex-grow: 1;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
    overflow-y: auto;
    padding: 0px;
}

  
  `;

  return (
    <>
      <style>{styleaccordion}</style>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
            className="col-12 mb-4 d-flex justify-content-between"
          >
            <div className="d-flex">
              <h5 className="m-0 p-3">Todays Appointments</h5>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3">
              <div className="d-flex align-items-center gap-3">
                <button
                  style={{ background: "none" }}
                  className="border-0"
                  type="button"
                  onClick={() => setViewType("List")}
                >
                  {/* <img src="/images/filter.png" alt="" /> */}
                  <i class="fa-solid fa-rectangle-list"></i>
                </button>
                <button
                  style={{ background: "none" }}
                  className="border-0"
                  type="button"
                  onClick={() => setViewType("Grid")}
                >
                  <i class="fa-solid fa-border-all"></i>
                  {/* <img src="/images/Grid.png" alt="" /> */}
                </button>

                <button
                  onClick={handleShow}
                  type="button"
                  style={{
                    background: "#FAFFFB",
                    padding: ".3rem .6rem",
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                  }}
                  className="rounded-1"
                >
                  <img
                    style={{ width: "1rem" }}
                    src="/Images/filter123.svg"
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
          {/* <div className="col-12 d-flex align-items-center mb-4 justify-content-end">
            <span>Choose Date<DatePicker style={{marginLeft:"1rem"}} />  </span>
        </div> */}
        </div>

        {viewType === "List" && (
          <div className="row">
            <div className="col-12 p-0">
              <TodaysAppointmentsTable />
            </div>
          </div>
        )}

        {viewType === "Grid" && (
          <div className="row">
            <div className="col-12 p-0">
              <TodaysAppointmentGrid />
            </div>
          </div>
        )}

        <Offcanvas
          show={show}
          onHide={handleClose}
          placement={"end"}
          style={{
            width: "22rem",
            margin: ".5rem .5rem",
            borderRadius: "0.5rem 0rem 0px .5rem",
          }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              className="text-black"
              style={{ fontSize: "18px" }}
            >
              Filters
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="">
              <PanelGroup accordion className="no-border">
                <Panel header="Appointment Status">
                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Upcoming </span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Completed </span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Reason">
                  <div className="position-relative div-okij8ijj mb-3">
                    <input
                      type="text"
                      className="form-control div-sdwfegere"
                      placeholder="Search"
                      style={{ padding: ".3rem .2rem", borderRadius: ".3rem" }}
                    />
                    <div
                      className="position-absolute"
                      style={{ top: "5px", right: ".2rem" }}
                    >
                      <button style={{ background: "none", border: "none" }}>
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>General Checkup</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Diagnosis</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Follow-up</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Blood Test</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Vaccination</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Prescription Refill</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Physical Therapy</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Specialist Consultation</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Mental Health Support</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Surgical Evaluation</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Visit Type">
                  <div className="position-relative div-okij8ijj mb-3">
                    <input
                      type="text"
                      className="form-control div-sdwfegere"
                      placeholder="Search"
                      style={{ padding: ".3rem .2rem", borderRadius: ".3rem" }}
                    />
                    <div
                      className="position-absolute"
                      style={{ top: "5px", right: ".2rem" }}
                    >
                      <button style={{ background: "none", border: "none" }}>
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>In-person</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Virtual</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Emergency</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Walk-in</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Home Visit</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Telehealth</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Consultation</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Second Opinion</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Follow-up Visit</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Time Slot">
                  <div className="d-flex align-items-center gap-2">
                    <input type="date" className="form-control" />
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Morning (8 AM - 12 PM)</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Afternoon (12 PM - 4 PM)</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Evening (4 PM - 8 PM)</span>
                  </div>
                </Panel>
              </PanelGroup>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </main>
    </>
  );
}

export default TodaysAppointments;
